import { render, staticRenderFns } from "./ComprobantePdf.vue?vue&type=template&id=5ab4b753&"
import script from "./ComprobantePdf.vue?vue&type=script&lang=js&"
export * from "./ComprobantePdf.vue?vue&type=script&lang=js&"
import style0 from "./ComprobantePdf.vue?vue&type=style&index=0&id=5ab4b753&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports